import { useQuery } from "@grandvisionhq/graphql";
import { useStockIndicator } from "@grandvisionhq/inventory";
import GET_MY_WISHLIST from "../../operations/queries/operations/queries/get-my-wishlist.js";
import { mapShoppingListToWishlistItems } from "../../utils/utils/map-shopping-list-to-wishlist-items.js";
const useGetUserWishlist = ({
  locale,
  isAuthLoading,
  isUserLoggedIn
}) => {
  const { thresholds } = useStockIndicator();
  const userWishlistQueryOptions = {
    context: { forwardHeaders: { "Accept-Language": locale } },
    skip: isAuthLoading || !isUserLoggedIn
  };
  const {
    data: userWishlistData,
    loading: isLoading,
    error,
    refetch
  } = useQuery(GET_MY_WISHLIST, {
    ...userWishlistQueryOptions
  });
  const wishlistId = userWishlistData?.me?.wishlist?.id ?? "";
  const mappedUserData = {
    items: userWishlistData?.me?.wishlist ? mapShoppingListToWishlistItems(locale, userWishlistData.me.wishlist, thresholds) : [],
    id: wishlistId
  };
  return {
    data: !error ? mappedUserData : null,
    loading: isLoading,
    error,
    refetch: async () => {
      await refetch();
    }
  };
};
export {
  useGetUserWishlist
};
//# sourceMappingURL=use-get-user-wishlist.js.map
